import React from 'react';
import styled from 'styled-components';

export function MatterFilters(props) {
  return (
    <StyledMatterFilters>
      <MatterFilter filter={props.filter} setFilter={props.setFilter} />
      <label>
        <input
          type="checkbox"
          defaultChecked={props.byRecent}
          onChange={props.toggleRecent}
        />
        <span>Most recent first</span>
      </label>
    </StyledMatterFilters>
  );
}

function MatterFilter({ filter, setFilter }) {
  return (
    <StyledMatterFilter className="filter">
      <i className="fa fa-search" />
      <input
        placeholder="Filter by name"
        defaultValue={filter}
        onChange={e => setFilter(e.target.value)}
      />
    </StyledMatterFilter>
  );
}

const StyledMatterFilter = styled.label`
  background: white;
  border: 1px solid #dededb;
  border-radius: 3px;
  font-family: 'Zilla Slab', serif;
  font-size: 15px;
  padding: 10px 12px;
  margin-right: 20px;
  flex: 1 1 auto !important;
  i {
    margin-right: 10px;
    font-size: 12px;
  }
`;

const StyledMatterFilters = styled.div`
  display: flex;
  align-items: center;
  label {
    flex: 0 1 auto;
    display: inline-block;
    input + span {
      margin-left: 10px;
    }
  }
`;
